module.exports = __webpack_public_path__ + "static/media/acroAcroPoseAcroYoga1139491@3x.e5b419b2.png";